import React from "react";
import { Cpu, Headphones, Network, ShieldCheck, Wifi } from "lucide-react";
import { CampusLifeShell, PageSection, ResponsiveTable } from "./CampusLifePageParts";

const networkHighlights = [
  ["Network Nodes", "500+ Connected Nodes"],
  ["Network Backbone", "Fiber Optic Infrastructure"],
  ["Supported Users", "2500+ Students, Faculty & Staff"],
  ["Security Solution", "Sophos Network Security"],
  ["Campus Connectivity", "LAN Access Across Campus"],
];

const facilityServices = [
  ["Central Computing Facility", "State-of-the-art computing environment"],
  ["Technical Support", "Hardware and software support services"],
  ["Licensed Software Support", "Access to genuine and licensed software packages"],
  ["High-End Computing Systems", "Advanced computing resources for academic use"],
  ["Server Infrastructure", "Dedicated server room with enterprise-grade security"],
  ["Network Security", "Cyberoam Firewall protection against external threats"],
  ["Campus Wi-Fi", "Wireless connectivity at strategic locations"],
  ["Hostel Wi-Fi", "Internet access available after academic hours"],
];

const specifications = [
  ["High-Speed Internet", "500 Mbps OFC Leased Line"],
  ["Dedicated Internet Access", "24x7 Internet Connectivity"],
  ["Academic Internet Facility", "100 Mbps Dedicated Access"],
  ["Campus LAN", "Fiber Optic Backbone Network"],
  ["Wi-Fi Coverage", "Academic Blocks, Hostels & Key Locations"],
  ["Security Monitoring", "Sophos Security Suite & Firewall Protection"],
];

const WifiCampus = () => (
  <CampusLifeShell
    title="Wi-Fi Campus"
    short="Wi-Fi"
    image="/Campus/wifi.jpg"
    navItems={[
      // ["#overview", "Overview"],
      // ["#network", "Network Highlights"],
      // ["#services", "Facility Services"],
      // ["#specifications", "Specifications"],
    ]}
    quickFacts={[
      ["Category", "Campus Life"],
      ["Facility", "Wi-Fi Campus"],
      ["Internet", "500 Mbps OFC Leased Line"],
      ["Users", "2500+ Students, Faculty & Staff"],
      ["Nodes", "500+ Connected Nodes"],
      ["Security", "Sophos Network Security"],
    ]}
  >
    <PageSection id="overview" title="Computer Center" icon={Cpu}>
      <span className="text-xs tracking-[0.2em] text-brand font-sans-ui font-semibold">
        Campus Digital Infrastructure
      </span>
      <div className="space-y-4 mt-3 text-[#2a2a2a]/85 leading-relaxed text-[15.5px]">
        <p>
          The Computer Center (CC), often regarded as the neural system of the
          institution, provides uninterrupted computing and networking services
          24x7 throughout the year. It serves as the backbone of the campus's
          digital infrastructure by offering essential IT services such as
          Internet connectivity, Email services, Web hosting, DNS management,
          CCTV monitoring, Feedback systems, and Antivirus protection.
        </p>
        <p>
          Established with the objective of creating a robust computational
          environment for academic and research activities, the Computer Center
          supports students, faculty, researchers, administrative offices, and
          staff. In addition to infrastructure support, the center also offers
          training, technical assistance, and consultancy services. Advanced
          software solutions, including Sophos security services, are provided
          to ensure a secure and productive computing environment.
        </p>
      </div>
    </PageSection>

    <PageSection id="network" title="Network Highlights" icon={Network}>
      <ResponsiveTable columns={["Facility", "Details"]} rows={networkHighlights} />
    </PageSection>

    <PageSection id="services" title="Facility Services" icon={Headphones}>
      <ResponsiveTable columns={["Service", "Description"]} rows={facilityServices} />
    </PageSection>

    <PageSection id="specifications" title="Facility Specifications" icon={ShieldCheck}>
      <ResponsiveTable columns={["Facility", "Specification"]} rows={specifications} />
    </PageSection>

    <PageSection id="connectivity" title="Campus Connectivity" icon={Wifi}>
      <p className="bg-white border border-brand/15 p-4 text-[#2a2a2a]/85 leading-relaxed text-[15.5px]">
        LAN and wireless connectivity support academic blocks, hostels, and key
        campus locations, helping students and staff access digital resources
        reliably across the institution.
      </p>
    </PageSection>
  </CampusLifeShell>
);

export default WifiCampus;
